import React, { Fragment, type FC } from 'react'

import { useRecoilValue } from 'recoil'

import {
  Flex,
  FlexItem,
  Grid,
  GridCell,
  TEXT_VARIANT_BOLD,
  Text,
} from 'mailup-web-components'

import type { SearchResult } from 'Pages/RecipientsList/model'

import { dynamicFieldsState } from 'Pages/RecipientsList/recoil/state/columns'

import InputField from 'Pages/RecipientsList/components/aside/InputField'

interface BoxDynamicFieldsProps {
  item: SearchResult
}

const BoxDynamicFields: FC<BoxDynamicFieldsProps> = ({ item: { Fields } }) => {
  const dynamicFields = useRecoilValue(dynamicFieldsState)

  return (
    <Flex margin="16px 0 0 0">
      <Grid cols={12} variantVertical="0px">
        {Fields.map(({ id, value }) => (
          <Fragment key={id}>
            <GridCell span={5}>
              <Flex alignItems="flex-start" gap="16px" minHeight="36px">
                <FlexItem flexBasis="16px" padding="10px 0">
                  <Text variant={TEXT_VARIANT_BOLD}>{id}</Text>
                </FlexItem>
                <FlexItem padding="10px 0">
                  <Text variant={TEXT_VARIANT_BOLD} wordBreak="break-all">
                    {
                      dynamicFields.find(({ id: fieldId }) => fieldId === id)
                        ?.description
                    }
                  </Text>
                </FlexItem>
              </Flex>
            </GridCell>
            <GridCell span={7}>
              <InputField fieldId={id} value={value} />
            </GridCell>
          </Fragment>
        ))}
      </Grid>
    </Flex>
  )
}

export default BoxDynamicFields
